export default __webpack_public_path__ + "static/media/142F2C55-6B2E-4821-8967-F05D18FF928A.16a68f97.jpg";